import { useQuery } from "@tanstack/react-query";
import { getBranding } from "./api";

/** Company name + logo presence, for the app header and the login page.
 *  Public (no auth), cached for a few minutes. */
export function useBranding() {
  return useQuery({
    queryKey: ["branding"],
    queryFn: getBranding,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
